import React from 'react';

import {ExpandableList} from "../../../core/components/list/components/expandable-list";
import {PreviousMeetingsWidgetHeader} from "./previous-meetings-widget.header";
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {PreviousMeetingsWidgetMatchRow} from "./previous-meetings-widget.match-row";
import {APP} from "../../../core/app/consts";
import {PREVIOUS_MEETINGS} from "../previous-meetings-widget.consts";
import {observer} from "mobx-react";
import styles from "../styles/previous-meetings-widget.view.module.scss";
import classNames from "classnames";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export class PreviousMeetingsWidgetViewComponentProps extends PreviousMeetingsWidgetProps {
}

export const PreviousMeetingsWidgetView = observer(({
                                                      controller,
                                                      isFullView
                                                    }: PreviousMeetingsWidgetViewComponentProps) => {

  const {state, device} = controller;
  const {isExpanded, terms, matches, gameId, collapsedLimit, isEmptyState} = state;
  const {isLargeView} = device;

  const listProps = {
    expanded: isExpanded,
    toggleExpand: () => controller.action(PREVIOUS_MEETINGS.ACTION_TYPES.toggleCollapsed),
    expandedText: terms.SEE_MORE,
    collapsedText: terms.SEE_LESS,
    children: matches,
    ListItem: PreviousMeetingsWidgetMatchRow,
    listItemProps: {controller},
    name: 'previous-meetings',
    action: 'match-details',
    label: 'show-more',
    maxResultsOnCollapse: collapsedLimit,
    maxResults: isFullView ? matches?.length : 0,
    source: APP.ANALYTICS.SOURCES.previousMeetings,
    gameId: gameId,
    style: {
      backgroundColor: useThemeColor(COLORS.whitePrimary)
    }
  }

  return (
    <div className={classNames(styles.container)}>
      {
        !isEmptyState && isLargeView &&
        <div className={classNames(styles.title)}>{terms.WEB_H2H_TITLE}</div>
      }
      <PreviousMeetingsWidgetHeader controller={controller}/>
      <ExpandableList {...listProps} />
    </div>
  )
});
